(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__bsAnnV2Init) return;
  window.__bsAnnV2Init = true;

  var instances = {};

  /* The CSS default shift is 50%, which is exactly one group width when the
     track holds the two groups Liquid renders. That is already seamless
     whenever one group is at least as wide as the viewport. When it is
     narrower (few/short messages on a wide screen) two groups cannot fill the
     track and a gap would sweep through, so we clone the group up to the
     count that covers the viewport and pin the shift to a measured pixel
     width instead. Everything below is a refinement of a already-correct
     CSS-only state -- with JS off, the bar still scrolls correctly.

     A single-message bar never gets here: Liquid marks its track static. */
  function layout(el, state) {
    var track = el.querySelector('.bs-ann__track');
    var group = el.querySelector('[data-bs-ann-group]');
    if (!track || !group || track.classList.contains('bs-ann__track--static')) return;

    var groupWidth = group.getBoundingClientRect().width;
    var viewWidth = el.getBoundingClientRect().width;
    if (!groupWidth || !viewWidth) return;

    // Enough groups that the track always covers the viewport plus the one
    // group's worth of travel the animation consumes.
    var needed = Math.max(2, Math.ceil(viewWidth / groupWidth) + 1);
    var clones = track.querySelectorAll('[data-bs-ann-clone]');
    var have = clones.length + 1;

    if (needed === state.copies && have === needed) return;

    while (have < needed) {
      var copy = clones[0] ? clones[0].cloneNode(true) : group.cloneNode(true);
      copy.setAttribute('aria-hidden', 'true');
      copy.setAttribute('data-bs-ann-clone', '');
      copy.removeAttribute('data-bs-ann-group');
      // A cloned subtree is aria-hidden; anything focusable inside it would
      // otherwise be reachable by Tab but invisible to assistive tech.
      Array.prototype.forEach.call(copy.querySelectorAll('a[href]'), function (a) {
        a.setAttribute('tabindex', '-1');
      });
      track.appendChild(copy);
      have++;
    }
    while (have > needed) {
      var last = track.querySelector('[data-bs-ann-clone]:last-child');
      if (!last) break;
      track.removeChild(last);
      have--;
    }

    state.copies = needed;

    if (needed > 2) {
      track.style.setProperty('--bs-ann-shift', groupWidth.toFixed(3) + 'px');
    } else {
      track.style.removeProperty('--bs-ann-shift');
    }

    // Re-seat the animation so the new shift distance starts from a known
    // origin rather than mid-interpolation, which would read as a jump.
    track.style.animation = 'none';
    void track.offsetWidth;
    track.style.animation = '';
  }

  function initInstance(el) {
    if (!el || !el.id || el.__bsAnnInit) return;
    el.__bsAnnInit = true;

    var track = el.querySelector('.bs-ann__track');
    if (!track) return;

    var state = { copies: 0 };

    function setPaused(paused) {
      track.classList.toggle('bs-ann__track--paused', paused);
    }

    var focusedIn = false;
    var hidden = document.hidden;

    function refresh() { setPaused(focusedIn || hidden); }
    function onFocusIn() { focusedIn = true; refresh(); }
    function onFocusOut() { focusedIn = false; refresh(); }
    function onVisibility() { hidden = document.hidden; refresh(); }

    el.addEventListener('focusin', onFocusIn);
    el.addEventListener('focusout', onFocusOut);
    document.addEventListener('visibilitychange', onVisibility);

    var reduce = window.matchMedia
      ? window.matchMedia('(prefers-reduced-motion: reduce)')
      : null;

    var frame = 0;
    function relayout() {
      if (frame) return;
      frame = window.requestAnimationFrame(function () {
        frame = 0;
        if (reduce && reduce.matches) return;
        layout(el, state);
      });
    }

    var ro = null;
    if (window.ResizeObserver) {
      ro = new ResizeObserver(relayout);
      ro.observe(el);
    } else {
      window.addEventListener('resize', relayout);
    }

    if (reduce) {
      if (reduce.addEventListener) reduce.addEventListener('change', relayout);
      else if (reduce.addListener) reduce.addListener(relayout);
    }

    // Web fonts change text metrics after first paint; remeasure once they land.
    if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
      document.fonts.ready.then(relayout).catch(function () {});
    }

    relayout();

    instances[el.id] = {
      cleanup: function () {
        el.removeEventListener('focusin', onFocusIn);
        el.removeEventListener('focusout', onFocusOut);
        document.removeEventListener('visibilitychange', onVisibility);
        if (ro) ro.disconnect();
        else window.removeEventListener('resize', relayout);
        if (reduce) {
          if (reduce.removeEventListener) reduce.removeEventListener('change', relayout);
          else if (reduce.removeListener) reduce.removeListener(relayout);
        }
        if (frame) window.cancelAnimationFrame(frame);
        el.__bsAnnInit = false;
      }
    };
  }

  function destroyInstance(id) {
    var inst = instances[id];
    if (!inst) return;
    if (inst.cleanup) inst.cleanup();
    delete instances[id];
  }

  function announcementsIn(root) {
    var list = [];
    if (root.matches && root.matches('[data-bs-ann]')) list.push(root);
    if (root.querySelectorAll) {
      Array.prototype.forEach.call(root.querySelectorAll('[data-bs-ann]'), function (el) {
        list.push(el);
      });
    }
    return list;
  }

  function initAll(root) { announcementsIn(root).forEach(initInstance); }
  function destroyAll(root) { announcementsIn(root).forEach(function (el) { destroyInstance(el.id); }); }

  function ready(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  ready(function () { initAll(document); });

  document.addEventListener('shopify:section:load', function (evt) { initAll(evt.target); });
  document.addEventListener('shopify:section:unload', function (evt) { destroyAll(evt.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-faq"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__bsCollectionFaqInit) return;
  window.__bsCollectionFaqInit = true;

  function initInstance(root) {
    if (!root || root.__cfInit) return;
    var more = root.querySelector('[data-collection-faq-more]');
    if (!more) { root.__cfInit = true; return; }
    root.__cfInit = true;

    function onClick() {
      var extras = root.querySelectorAll('.bs-collection-faq__item--extra[hidden]');
      Array.prototype.forEach.call(extras, function (el) { el.hidden = false; });
      more.hidden = true;
    }
    more.addEventListener('click', onClick);
    root.__cfCleanup = function () { more.removeEventListener('click', onClick); };
  }

  function destroyInstance(root) {
    if (root && root.__cfCleanup) root.__cfCleanup();
    if (root) { root.__cfInit = false; root.__cfCleanup = null; }
  }

  function targetsIn(root) {
    var list = [];
    if (root.matches && root.matches('#bs-collection-faq')) list.push(root);
    if (root.querySelectorAll) {
      Array.prototype.forEach.call(root.querySelectorAll('#bs-collection-faq'), function (el) { list.push(el); });
    }
    return list;
  }

  function initAll(root) { targetsIn(root).forEach(initInstance); }
  function destroyAll(root) { targetsIn(root).forEach(destroyInstance); }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () { initAll(document); });

  document.addEventListener('shopify:section:load', function (evt) { initAll(evt.target); });
  document.addEventListener('shopify:section:unload', function (evt) { destroyAll(evt.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-hero-slideshow"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__bsChsInit) return;
  window.__bsChsInit = true;

  var instances = {};

  function idFromEl(el) {
    return el.id.replace(/^bs-chs-/, '');
  }

  function destroyInstance(id) {
    var inst = instances[id];
    if (!inst) return;
    if (inst.timer) clearInterval(inst.timer);
    if (inst.cleanup) inst.cleanup();
    delete instances[id];
  }

  function initInstance(el) {
    if (!el || !el.id) return;
    var id = idFromEl(el);
    destroyInstance(id);

    var track = el.querySelector('.bs-chs__track');
    var prevBtn = el.querySelector('.bs-chs__arrow--prev');
    var nextBtn = el.querySelector('.bs-chs__arrow--next');
    var dotsEl = el.querySelector('.bs-chs__dots');
    var slides = track ? Array.prototype.slice.call(track.querySelectorAll('.bs-chs__slide')) : [];
    var dots = dotsEl ? Array.prototype.slice.call(dotsEl.querySelectorAll('.bs-chs__dot')) : [];
    var total = slides.length;
    if (total === 0) return;

    var current = 0;
    var autoplayEnabled = el.getAttribute('data-autoplay') === 'true';
    var interval = (parseInt(el.getAttribute('data-interval'), 10) || 5) * 1000;
    var paused = false;
    var inst = { timer: null };

    function goTo(n) {
      current = ((n % total) + total) % total;
      if (track) track.style.transform = 'translateX(-' + (current * 100) + '%)';
      dots.forEach(function (d, i) { d.classList.toggle('active', i === current); });
    }

    function stopAuto() {
      if (inst.timer) clearInterval(inst.timer);
      inst.timer = null;
    }

    function startAuto() {
      stopAuto();
      if (paused || !autoplayEnabled || total <= 1) return;
      inst.timer = setInterval(function () { goTo(current + 1); }, interval);
    }

    function onPrev() { stopAuto(); goTo(current - 1); startAuto(); }
    function onNext() { stopAuto(); goTo(current + 1); startAuto(); }

    if (prevBtn) prevBtn.addEventListener('click', onPrev);
    if (nextBtn) nextBtn.addEventListener('click', onNext);

    var dotHandlers = dots.map(function (d, i) {
      var handler = function () { stopAuto(); goTo(i); startAuto(); };
      d.addEventListener('click', handler);
      return { el: d, handler: handler };
    });

    goTo(0);
    startAuto();

    inst.cleanup = function () {
      if (prevBtn) prevBtn.removeEventListener('click', onPrev);
      if (nextBtn) nextBtn.removeEventListener('click', onNext);
      dotHandlers.forEach(function (o) { o.el.removeEventListener('click', o.handler); });
    };

    inst.selectSlide = function (slideEl) {
      var idx = slides.indexOf(slideEl);
      if (idx === -1) return;
      paused = true;
      stopAuto();
      goTo(idx);
    };

    inst.deselectSlide = function () {
      paused = false;
      startAuto();
    };

    instances[id] = inst;
  }

  function carouselsIn(root) {
    var list = [];
    if (root.matches && root.matches('.bs-chs[id^="bs-chs-"]')) list.push(root);
    if (root.querySelectorAll) {
      Array.prototype.forEach.call(root.querySelectorAll('.bs-chs[id^="bs-chs-"]'), function (el) {
        list.push(el);
      });
    }
    return list;
  }

  function initAll(root) {
    carouselsIn(root).forEach(initInstance);
  }

  function destroyAll(root) {
    carouselsIn(root).forEach(function (el) { destroyInstance(idFromEl(el)); });
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () { initAll(document); });

  document.addEventListener('shopify:section:load', function (evt) {
    initAll(evt.target);
  });

  document.addEventListener('shopify:section:unload', function (evt) {
    destroyAll(evt.target);
  });

  document.addEventListener('shopify:block:select', function (evt) {
    var slideEl = evt.target && evt.target.closest ? evt.target.closest('.bs-chs__slide') : null;
    if (!slideEl) return;
    var carousel = slideEl.closest('.bs-chs[id^="bs-chs-"]');
    if (!carousel) return;
    var inst = instances[idFromEl(carousel)];
    if (inst && inst.selectSlide) inst.selectSlide(slideEl);
  });

  document.addEventListener('shopify:block:deselect', function (evt) {
    var slideEl = evt.target && evt.target.closest ? evt.target.closest('.bs-chs__slide') : null;
    if (!slideEl) return;
    var carousel = slideEl.closest('.bs-chs[id^="bs-chs-"]');
    if (!carousel) return;
    var inst = instances[idFromEl(carousel)];
    if (inst && inst.deselectSlide) inst.deselectSlide();
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-subcollection-hub"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__bsSubcolPillsInit) return;
  window.__bsSubcolPillsInit = true;

  var instances = {};
  // Shopify's Section Rendering (?section_id=) needs the fully-qualified
  // runtime id ("template--<numeric-template-id>__main"), which differs
  // between template files — a target collection routinely uses a
  // different template than the parent (e.g. a dedicated hero template vs.
  // the plain default), so a hardcoded id 404s across that boundary. A
  // full-page fetch of the target's own URL, extracting our own stable
  // #bs-collection-browser id from the response, works uniformly regardless
  // of which template the target resolves to.

  function reduceMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function isRtl(track) {
    return getComputedStyle(track).direction === 'rtl';
  }

  function scrollAmount(track) {
    var pill = track.querySelector('.bs-subcol-pill');
    if (!pill) return 200;
    var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
    return (pill.getBoundingClientRect().width + gap) * 2;
  }

  // Overflow is checked first: with no overflow at all there is nothing to
  // scroll to, so both arrows hide outright rather than showing as merely
  // "disabled".
  function updateButtons(inst) {
    var track = inst.track;
    var hasOverflow = track.scrollWidth > track.clientWidth + 4;
    if (!hasOverflow) {
      if (inst.prev) inst.prev.hidden = true;
      if (inst.next) inst.next.hidden = true;
      return;
    }
    var rtl = isRtl(track);
    var atStart = rtl ? track.scrollLeft >= -4 : track.scrollLeft <= 4;
    var atEnd = rtl
      ? track.scrollLeft <= -(track.scrollWidth - track.clientWidth - 4)
      : track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
    if (inst.prev) { inst.prev.hidden = false; inst.prev.disabled = atStart; }
    if (inst.next) { inst.next.hidden = false; inst.next.disabled = atEnd; }
  }

  function scrollByDir(inst, dir) {
    var rtl = isRtl(inst.track);
    var amt = scrollAmount(inst.track) * (rtl ? -dir : dir);
    inst.track.scrollBy({ left: amt, behavior: reduceMotion() ? 'auto' : 'smooth' });
  }

  function pillLabel(pill) {
    var label = pill.querySelector('.bs-subcol-pill__label');
    return (label ? label.textContent : pill.textContent).trim();
  }

  function findPillByHandle(track, handle) {
    var pills = track.querySelectorAll('.bs-subcol-pill[data-target-handle]');
    for (var i = 0; i < pills.length; i++) {
      if (pills[i].getAttribute('data-target-handle') === handle) return pills[i];
    }
    return null;
  }

  function reExecuteScripts(container) {
    var scripts = container.querySelectorAll('script');
    Array.prototype.forEach.call(scripts, function (old) {
      var fresh = document.createElement('script');
      Array.prototype.forEach.call(old.attributes, function (a) { fresh.setAttribute(a.name, a.value); });
      fresh.textContent = old.textContent;
      old.parentNode.replaceChild(fresh, old);
    });
  }

  // Collection FAQ (#bs-collection-faq) and Collection Notice
  // (#bs-collection-notice) both live outside the #bs-collection-browser
  // swap boundary but follow the identical always-present-wrapper contract:
  // present+populated in a fetched document means swap it in, absent means
  // the previous collection's content must be cleared+hidden rather than
  // left stale. Shared by performSwitch's own single-section fetch and by
  // reconcileAux's single-section fetch (see initInstance's fetchAuxSection)
  // — one function, two callers, so the swap semantics can't drift between
  // them.
  function syncAuxSection(id, doc) {
    var fresh = doc.getElementById(id);
    var current = document.getElementById(id);
    if (!current) return;
    if (fresh) {
      current.replaceWith(fresh);
    } else {
      current.innerHTML = '';
      current.hidden = true;
    }
  }

  // True if root itself, or a descendant of root, has the given id.
  // shopify:section:load's evt.target is documented as the reloaded
  // section's root element, but which exact node that is (the
  // #shopify-section-* wrapper vs. its first child) isn't guaranteed across
  // Shopify versions — matches whichever is actually the case.
  function containsOrIs(root, id) {
    if (!root) return null;
    if (root.id === id) return root;
    return root.querySelector ? root.querySelector('#' + id) : null;
  }

  function initInstance(root) {
    if (!root || root.__scpInit) return;

    var track = root.querySelector('[data-subcol-pills-track]');
    var prev = root.querySelector('[data-subcol-pills-prev]');
    var next = root.querySelector('[data-subcol-pills-next]');
    if (!track) return;

    root.__scpInit = true;

    var wrap = root.closest('.bs-container') || root.parentElement;
    var announce = wrap ? wrap.querySelector('[data-subcol-pills-announce]') : null;
    var errorBox = wrap ? wrap.querySelector('[data-subcol-pills-error]') : null;
    var retryBtn = errorBox ? errorBox.querySelector('[data-subcol-pills-retry]') : null;

    var rememberUrl = root.getAttribute('data-remember-url') === 'true';
    var parentUrl = root.getAttribute('data-parent-url') || '';

    var inst = { root: root, track: track, prev: prev, next: next };
    var abortController = null;
    var requestToken = 0;
    var pendingRetry = null;
    // True for the whole lifetime of a performSwitch call (full-page fetch,
    // set the instant it starts, cleared once applied or given up on) — lets
    // reconcileAux below tell "a real switch already owns this update" apart
    // from "nothing else is happening right now," without needing to touch
    // performSwitch's own abortController/requestToken at all.
    var switchInFlight = false;

    // Collection FAQ/Notice presentation (style overrides, spacing, glow,
    // max width) must always come from THIS hub page's own section
    // instance — the one actually visible/editable here in Theme Editor —
    // never from whichever subcollection happens to be active. Only their
    // CONTENT (title/body, sourced from the active collection's own
    // metafields) should vary by subcollection. Captured once, here, from
    // the as-server-rendered DOM before any switch ever runs (at this point
    // the wrapper's id — and its numeric template id — necessarily belongs
    // to this page's own template, since the server always renders using
    // the URL's own collection regardless of any ?subcollection= query
    // param). This id is invariant across every later switch: syncAuxSection
    // only ever replaces the inner #bs-collection-faq/#bs-collection-notice
    // div, never its outer shopify-section wrapper, so re-reading it later
    // would return the exact same value anyway.
    function hubSectionId(auxId) {
      var el = document.getElementById(auxId);
      var wrap = el ? el.closest('[id^="shopify-section-"]') : null;
      return wrap ? wrap.id.replace(/^shopify-section-/, '') : null;
    }
    var hubFaqSectionId = hubSectionId('bs-collection-faq');
    var hubNoticeSectionId = hubSectionId('bs-collection-notice');

    // Fetches one section, scoped to this hub's own section id, rendered
    // with whichever collection targetUrl points at — i.e. this page's own
    // settings + that collection's own content. Used by both performSwitch
    // (every ordinary switch/deep-link/popstate) and reconcileAux (Theme
    // Editor's independent per-section reload) so the two paths can never
    // resolve presentation settings differently from one another.
    function fetchAuxSection(sectionId, targetUrl) {
      if (!sectionId || !targetUrl) return Promise.resolve(null);
      var sep = targetUrl.indexOf('?') > -1 ? '&' : '?';
      return fetch(targetUrl + sep + 'section_id=' + encodeURIComponent(sectionId))
        .then(function (res) {
          if (!res.ok) throw new Error('bad-status');
          return res.text();
        })
        .then(function (html) { return new DOMParser().parseFromString(html, 'text/html'); })
        .catch(function () { return null; });
    }

    function onPrev() { scrollByDir(inst, -1); }
    function onNext() { scrollByDir(inst, 1); }
    function onScroll() { updateButtons(inst); }
    function onResize() { updateButtons(inst); }

    if (prev) prev.addEventListener('click', onPrev);
    if (next) next.addEventListener('click', onNext);
    track.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);

    inst.selectPill = function (pillEl) {
      pillEl.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
    };

    // Handles Collection FAQ/Collection Notice reloading independently of
    // this carousel (Shopify Theme Editor dispatches shopify:section:load
    // per-section on any settings change scoped to just that section). That
    // fresh section HTML is always rendered for the PARENT collection — the
    // section itself has no notion of "active subcollection" — so without
    // this, FAQ/Notice would silently revert to the parent's state while the
    // pill row and product grid still correctly show the active child.
    //
    // Reads the DOM's currently-.active pill rather than the URL's
    // ?subcollection= param: setActivePill() runs synchronously at the very
    // start of performSwitch, before its fetch even begins, while the URL
    // itself is only updated by pushState once that fetch resolves — the
    // active pill in the DOM is always the single, immediately-current
    // source of truth for "what's active right now," matching every other
    // surface, and is never stale the way re-parsing the URL could be.
    //
    // Deliberately does NOT share performSwitch's abortController: a
    // reconciliation must never be able to cancel a real, in-flight pill
    // switch (confirmed live — sharing one controller let a reconciliation
    // triggered mid-switch abort the switch's own full-page fetch, leaving
    // the product grid stuck in its loading state and the URL never
    // pushed). Instead: skip entirely while a switch is in flight (it will
    // correctly sync every surface itself once it resolves — no need to
    // race it), and re-check the active pill hasn't changed once this
    // fetch resolves before applying anything, so a switch that starts and
    // finishes while a reconciliation fetch is still in the air can never
    // be clobbered by that reconciliation's now-stale result. Never touches
    // history or scroll/focus — this is a silent background consistency
    // fix, not a navigation.
    function reconcileAux(auxId) {
      if (switchInFlight) return; // a real switch owns the truth right now — it will sync this itself
      var activePill = track.querySelector('.bs-subcol-pill.active');
      var handle = activePill ? (activePill.getAttribute('data-target-handle') || '') : '';
      if (!handle) return; // parent (All Items) active — the fresh section HTML is already correct
      var baseUrl = activePill.getAttribute('href');
      if (!baseUrl) return;
      var sectionId = auxId === 'bs-collection-faq' ? hubFaqSectionId : hubNoticeSectionId;

      fetchAuxSection(sectionId, baseUrl).then(function (doc) {
        if (!doc) return;
        if (switchInFlight) return; // a real switch started/settled while this was in flight — defer to it
        var nowActive = track.querySelector('.bs-subcol-pill.active');
        var nowHandle = nowActive ? (nowActive.getAttribute('data-target-handle') || '') : '';
        if (nowHandle !== handle) return; // active pill changed since this fetch started — stale, discard
        syncAuxSection(auxId, doc);
      });
    }
    inst.reconcileAux = reconcileAux;

    function getBrowser() { return document.getElementById('bs-collection-browser'); }

    function setActivePill(pill) {
      var pills = track.querySelectorAll('.bs-subcol-pill');
      Array.prototype.forEach.call(pills, function (p) {
        p.classList.remove('active');
        p.removeAttribute('aria-current');
      });
      if (pill) {
        pill.classList.add('active');
        pill.setAttribute('aria-current', 'page');
      }
    }

    function announceText(text) {
      if (announce) announce.textContent = text;
    }

    function hideError() { if (errorBox) errorBox.hidden = true; }
    function showError() { if (errorBox) errorBox.hidden = false; }

    function performSwitch(pill, url, handle, label, pushHistory) {
      var browser = getBrowser();
      if (!browser || !url) return;

      hideError();
      var previousPill = track.querySelector('.bs-subcol-pill.active');
      setActivePill(pill);
      browser.setAttribute('aria-busy', 'true');
      browser.classList.add('bs-collection-browser--loading');
      switchInFlight = true;

      if (abortController) abortController.abort();
      abortController = (typeof AbortController !== 'undefined') ? new AbortController() : null;
      var myToken = ++requestToken;

      fetch(url, abortController ? { signal: abortController.signal } : {})
        .then(function (res) {
          if (!res.ok) throw new Error('bad-status');
          return res.text();
        })
        .then(function (html) {
          if (myToken !== requestToken) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.getElementById('bs-collection-browser');
          if (!fresh) throw new Error('missing-browser-markup');

          var focusTarget = fresh;
          browser.replaceWith(fresh);
          reExecuteScripts(fresh);
          if (window.BSNovaCurrency) window.BSNovaCurrency.notifyDomUpdated(fresh);

          fresh.setAttribute('tabindex', '-1');
          if (focusTarget.focus) focusTarget.focus({ preventScroll: true });

          announceText(label);
          if (pushHistory && rememberUrl) {
            var newUrl = parentUrl + (handle ? ('?subcollection=' + encodeURIComponent(handle)) : '');
            history.pushState({ bsSubcollection: handle || '' }, '', newUrl);
          }

          // Collection FAQ and Collection Notice both live outside the
          // #bs-collection-browser swap boundary. Resolved via THIS hub's
          // own section instance (settings) + the target's own URL
          // (content) — see hubFaqSectionId/hubNoticeSectionId above — so a
          // pill click/deep-link/popstate can never disagree with what
          // Theme Editor's reconcileAux already does for the same section.
          // Falls back to extracting from the full-page fetch above only if
          // this page genuinely has no such section at all.
          var auxDone = Promise.all([
            hubFaqSectionId ? fetchAuxSection(hubFaqSectionId, url) : Promise.resolve(doc),
            hubNoticeSectionId ? fetchAuxSection(hubNoticeSectionId, url) : Promise.resolve(doc)
          ]).then(function (docs) {
            if (myToken !== requestToken) return;
            if (docs[0]) syncAuxSection('bs-collection-faq', docs[0]);
            if (docs[1]) syncAuxSection('bs-collection-notice', docs[1]);
          });

          auxDone.then(function () {
            if (myToken === requestToken) switchInFlight = false;
          });
        })
        .catch(function (err) {
          if (myToken !== requestToken) return;
          switchInFlight = false;
          if (err && err.name === 'AbortError') return;
          var current = getBrowser();
          if (current) {
            current.removeAttribute('aria-busy');
            current.classList.remove('bs-collection-browser--loading');
          }
          setActivePill(previousPill);
          pendingRetry = { pill: pill, url: url, handle: handle, label: label, pushHistory: pushHistory };
          showError();
        });
    }

    track.addEventListener('click', function (e) {
      var pill = e.target.closest('.bs-subcol-pill');
      if (!pill || !track.contains(pill)) return;
      if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      e.preventDefault();
      if (pill.classList.contains('active')) return;
      var handle = pill.getAttribute('data-target-handle') || '';
      performSwitch(pill, pill.getAttribute('href'), handle, pillLabel(pill), true);
    });

    if (retryBtn) {
      retryBtn.addEventListener('click', function () {
        if (!pendingRetry) return;
        performSwitch(pendingRetry.pill, pendingRetry.url, pendingRetry.handle, pendingRetry.label, pendingRetry.pushHistory);
      });
    }

    function onPopState() {
      var params = new URLSearchParams(window.location.search);
      var handle = params.get('subcollection') || '';
      var pill = handle ? findPillByHandle(track, handle) : track.querySelector('.bs-subcol-pill--all');
      if (!pill) pill = track.querySelector('.bs-subcol-pill--all');
      if (!pill) return;
      performSwitch(pill, pill.getAttribute('href'), handle, pillLabel(pill), false);
    }
    window.addEventListener('popstate', onPopState);

    inst.destroy = function () {
      if (prev) prev.removeEventListener('click', onPrev);
      if (next) next.removeEventListener('click', onNext);
      track.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onResize);
      window.removeEventListener('popstate', onPopState);
      if (abortController) abortController.abort();
      root.__scpInit = false;
    };

    // Deep link on initial load: ?subcollection=<handle> loads that
    // selection without a page reload. An invalid/deleted handle is simply
    // ignored — the server-rendered "All Items" state already stands.
    var initialHandle = new URLSearchParams(window.location.search).get('subcollection');
    if (initialHandle) {
      var initialPill = findPillByHandle(track, initialHandle);
      if (initialPill) {
        performSwitch(initialPill, initialPill.getAttribute('href'), initialHandle, pillLabel(initialPill), false);
      }
    }

    updateButtons(inst);
    instances[root.id] = inst;
  }

  function destroyInstance(id) {
    var inst = instances[id];
    if (!inst) return;
    inst.destroy();
    delete instances[id];
  }

  function carouselsIn(root) {
    var list = [];
    if (root.matches && root.matches('[data-subcol-pills-carousel]')) list.push(root);
    if (root.querySelectorAll) {
      Array.prototype.forEach.call(root.querySelectorAll('[data-subcol-pills-carousel]'), function (el) { list.push(el); });
    }
    return list;
  }

  function initAll(root) { carouselsIn(root).forEach(initInstance); }
  function destroyAll(root) { carouselsIn(root).forEach(function (el) { destroyInstance(el.id); }); }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () { initAll(document); });

  document.addEventListener('shopify:section:load', function (evt) {
    initAll(evt.target);

    // If this reload is Collection FAQ or Collection Notice reloading on
    // its own (not this carousel's own section, which self-heals via the
    // deep-link restore above — a fresh carousel re-render re-reads the
    // still-current ?subcollection= URL itself), reconcile it against the
    // active subcollection. See reconcileAux() in initInstance for why this
    // is needed at all.
    var reloadedFaq = containsOrIs(evt.target, 'bs-collection-faq');
    var reloadedNotice = containsOrIs(evt.target, 'bs-collection-notice');
    if (!reloadedFaq && !reloadedNotice) return;

    var carousel = document.querySelector('[data-subcol-pills-carousel]');
    var inst = carousel ? instances[carousel.id] : null;
    // No initialized carousel yet means this is part of the same initial
    // boot as the carousel's own section — its upcoming init will run the
    // deep-link restore and sync everything itself; nothing to reconcile.
    if (!inst || !inst.reconcileAux) return;

    if (reloadedFaq) inst.reconcileAux('bs-collection-faq');
    if (reloadedNotice) inst.reconcileAux('bs-collection-notice');
  });

  document.addEventListener('shopify:section:unload', function (evt) {
    destroyAll(evt.target);
  });

  document.addEventListener('shopify:block:select', function (evt) {
    var pillEl = evt.target && evt.target.closest ? evt.target.closest('.bs-subcol-pill') : null;
    if (!pillEl) return;
    var carousel = pillEl.closest('[data-subcol-pills-carousel]');
    if (!carousel) return;
    var inst = instances[carousel.id];
    if (inst && inst.selectPill) inst.selectPill(pillEl);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["game-rows"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__bsGameTabsInit) return;
  window.__bsGameTabsInit = true;

  var instances = {};

  function initInstance(section) {
    if (!section || section.__gtInit) return;

    var pills  = section.querySelectorAll('.bs-game-tabs__pill[data-tab]');
    var panels = section.querySelectorAll('.bs-game-tabs__panel');
    if (!pills.length) return;

    section.__gtInit = true;

    var handlers = [];
    pills.forEach(function (pill) {
      function onClick() {
        pills.forEach(function (p) {
          p.classList.remove('active');
          p.setAttribute('aria-selected', 'false');
        });
        pill.classList.add('active');
        pill.setAttribute('aria-selected', 'true');

        panels.forEach(function (panel) {
          panel.classList.remove('active');
          panel.setAttribute('aria-hidden', 'true');
        });
        var target = section.querySelector('#bs-tab-' + pill.getAttribute('data-tab'));
        if (target) {
          target.classList.add('active');
          target.setAttribute('aria-hidden', 'false');
        }
      }
      pill.addEventListener('click', onClick);
      handlers.push({ el: pill, fn: onClick });
    });

    instances[section.id] = {
      destroy: function () {
        handlers.forEach(function (h) { h.el.removeEventListener('click', h.fn); });
        section.__gtInit = false;
      }
    };
  }

  function destroyInstance(section) {
    var inst = instances[section.id];
    if (!inst) return;
    inst.destroy();
    delete instances[section.id];
  }

  function sectionsIn(root) {
    var list = [];
    if (root.matches && root.matches('[data-game-tabs]')) list.push(root);
    if (root.querySelectorAll) {
      Array.prototype.forEach.call(root.querySelectorAll('[data-game-tabs]'), function (el) { list.push(el); });
    }
    return list;
  }

  function initAll(root) { sectionsIn(root).forEach(initInstance); }
  function destroyAll(root) { sectionsIn(root).forEach(destroyInstance); }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () { initAll(document); });

  document.addEventListener('shopify:section:load', function (evt) {
    initAll(evt.target);
  });

  document.addEventListener('shopify:section:unload', function (evt) {
    destroyAll(evt.target);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero-bloxshop"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__bsHeroRotInit) return;
  window.__bsHeroRotInit = true;

  var instances = {};

  function reduceMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function destroyInstance(id) {
    var inst = instances[id];
    if (!inst) return;
    if (inst.timer) clearInterval(inst.timer);
    if (inst.cleanup) inst.cleanup();
    delete instances[id];
  }

  function initInstance(el) {
    if (!el || !el.id) return;
    var id = el.id;
    destroyInstance(id);

    var currentEl = el.querySelector('.bs-rot__current');
    var listEl = el.querySelector('.bs-rot__list');
    if (!currentEl || !listEl) return;

    var items = Array.prototype.slice.call(listEl.querySelectorAll('.bs-rot__item'));
    var words = items.map(function (item) { return item.getAttribute('data-word'); }).filter(Boolean);
    if (words.length === 0) return;

    var inst = { timer: null, swap: null, index: 0, words: words, items: items, el: el, currentEl: currentEl };
    var widths = [];

    // Measure each name individually. Reserving the *widest* name instead would
    // leave a dead gap after every shorter one and break the sentence rhythm.
    function measure() {
      var probe = document.createElement('span');
      var cs = window.getComputedStyle(currentEl);
      probe.style.position = 'absolute';
      probe.style.visibility = 'hidden';
      probe.style.whiteSpace = 'pre';
      probe.style.fontFamily = cs.fontFamily;
      probe.style.fontSize = cs.fontSize;
      probe.style.fontWeight = cs.fontWeight;
      probe.style.fontStyle = cs.fontStyle;
      probe.style.letterSpacing = cs.letterSpacing;
      probe.style.textTransform = cs.textTransform;
      document.body.appendChild(probe);
      widths = words.map(function (w) {
        probe.textContent = w;
        return Math.ceil(probe.getBoundingClientRect().width);
      });
      document.body.removeChild(probe);
    }

    // If even the longest name cannot sit on one line, let it wrap normally rather
    // than pinning a width that would push the sentence out of the hero.
    function applyWidth() {
      var widest = widths.length ? Math.max.apply(null, widths) : 0;
      var parent = el.parentElement;
      var room = parent ? parent.getBoundingClientRect().width : 0;
      if (!widest || (room && widest > room)) {
        el.classList.add('bs-rot--fluid');
        el.style.width = '';
        return;
      }
      el.classList.remove('bs-rot--fluid');
      el.style.width = widths[inst.index] + 'px';
    }

    function show(i) {
      var next = ((i % words.length) + words.length) % words.length;
      currentEl.classList.add('bs-rot__current--out');
      if (inst.swap) window.clearTimeout(inst.swap);
      // Swap the text and the reserved width together, at the moment the word is
      // invisible. Resizing earlier would leave the outgoing (possibly much wider)
      // name inside a box already shrunk to the next one, spilling it over the
      // following text. The box then eases to its new width while the new name
      // fades in; .bs-rot clips so nothing can escape mid-transition.
      inst.swap = window.setTimeout(function () {
        inst.index = next;
        currentEl.textContent = words[next];
        applyWidth();
        currentEl.classList.remove('bs-rot__current--out');
        inst.swap = null;
      }, 180);
    }

    inst.show = show;
    inst.preview = function (idx) {
      if (idx < 0 || idx >= words.length) return;
      inst.index = idx;
      currentEl.textContent = words[idx];
      applyWidth();
    };

    measure();
    applyWidth();

    var resizeTimer = null;
    function onResize() {
      if (resizeTimer) window.clearTimeout(resizeTimer);
      resizeTimer = window.setTimeout(function () { measure(); applyWidth(); }, 150);
    }
    window.addEventListener('resize', onResize);

    // Web fonts change the metrics, so re-measure once they have settled.
    if (document.fonts && document.fonts.ready && document.fonts.ready.then) {
      document.fonts.ready.then(function () {
        if (instances[id] !== inst) return;
        measure();
        applyWidth();
      });
    }

    inst.cleanup = function () {
      window.removeEventListener('resize', onResize);
      if (resizeTimer) window.clearTimeout(resizeTimer);
      if (inst.swap) window.clearTimeout(inst.swap);
    };

    if (!reduceMotion() && words.length > 1) {
      var interval = parseInt(el.getAttribute('data-interval'), 10) || 3000;
      inst.timer = setInterval(function () { show(inst.index + 1); }, interval);
    }

    instances[id] = inst;
  }

  function rotatorsIn(root) {
    var list = [];
    if (root.matches && root.matches('.bs-rot[id]')) list.push(root);
    if (root.querySelectorAll) {
      Array.prototype.forEach.call(root.querySelectorAll('.bs-rot[id]'), function (el) { list.push(el); });
    }
    return list;
  }

  function initAll(root) {
    rotatorsIn(root).forEach(initInstance);
  }

  function destroyAll(root) {
    rotatorsIn(root).forEach(function (el) { destroyInstance(el.id); });
  }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () { initAll(document); });

  document.addEventListener('shopify:section:load', function (evt) {
    initAll(evt.target);
  });

  document.addEventListener('shopify:section:unload', function (evt) {
    destroyAll(evt.target);
  });

  document.addEventListener('shopify:block:select', function (evt) {
    var itemEl = evt.target && evt.target.closest ? evt.target.closest('.bs-rot__item') : null;
    if (!itemEl) return;
    var rotEl = itemEl.closest('.bs-rot[id]');
    if (!rotEl) return;
    var inst = instances[rotEl.id];
    if (!inst || !inst.preview) return;
    var idx = inst.items.indexOf(itemEl);
    if (idx === -1) return;
    if (inst.timer) { clearInterval(inst.timer); inst.timer = null; }
    inst.preview(idx);
  });

  document.addEventListener('shopify:block:deselect', function (evt) {
    var itemEl = evt.target && evt.target.closest ? evt.target.closest('.bs-rot__item') : null;
    if (!itemEl) return;
    var rotEl = itemEl.closest('.bs-rot[id]');
    if (!rotEl) return;
    initInstance(rotEl);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-before-after"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__bsBaInit) return;
  window.__bsBaInit = true;

  var instances = {};

  function destroyInstance(id) {
    var inst = instances[id];
    if (!inst) return;
    if (inst.cleanup) inst.cleanup();
    delete instances[id];
  }

  function initInstance(el) {
    if (!el || !el.id) return;
    var id = el.id;
    destroyInstance(id);

    var range = el.querySelector('.bs-ba__range');
    if (!range) return;

    function setPos(pct) {
      pct = Math.max(0, Math.min(100, pct));
      el.style.setProperty('--bs-ba-pos', pct + '%');
      range.value = pct;
    }

    function pctFromClientX(clientX) {
      var rect = el.getBoundingClientRect();
      if (rect.width === 0) return parseFloat(range.value);
      return ((clientX - rect.left) / rect.width) * 100;
    }

    var dragging = false;

    function onPointerDown(evt) {
      dragging = true;
      var x = evt.touches ? evt.touches[0].clientX : evt.clientX;
      setPos(pctFromClientX(x));
      evt.preventDefault();
    }
    function onPointerMove(evt) {
      if (!dragging) return;
      var x = evt.touches ? evt.touches[0].clientX : evt.clientX;
      setPos(pctFromClientX(x));
    }
    function onPointerUp() { dragging = false; }
    function onRangeInput() { setPos(parseFloat(range.value)); }

    el.addEventListener('mousedown', onPointerDown);
    el.addEventListener('touchstart', onPointerDown, { passive: false });
    window.addEventListener('mousemove', onPointerMove);
    window.addEventListener('touchmove', onPointerMove, { passive: false });
    window.addEventListener('mouseup', onPointerUp);
    window.addEventListener('touchend', onPointerUp);
    range.addEventListener('input', onRangeInput);

    setPos(parseFloat(range.value));

    instances[id] = {
      cleanup: function () {
        el.removeEventListener('mousedown', onPointerDown);
        el.removeEventListener('touchstart', onPointerDown);
        window.removeEventListener('mousemove', onPointerMove);
        window.removeEventListener('touchmove', onPointerMove);
        window.removeEventListener('mouseup', onPointerUp);
        window.removeEventListener('touchend', onPointerUp);
        range.removeEventListener('input', onRangeInput);
      }
    };
  }

  function slidersIn(root) {
    var list = [];
    if (root.matches && root.matches('.bs-ba[id]')) list.push(root);
    if (root.querySelectorAll) {
      Array.prototype.forEach.call(root.querySelectorAll('.bs-ba[id]'), function (el) { list.push(el); });
    }
    return list;
  }

  function initAll(root) { slidersIn(root).forEach(initInstance); }
  function destroyAll(root) { slidersIn(root).forEach(function (el) { destroyInstance(el.id); }); }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () { initAll(document); });

  document.addEventListener('shopify:section:load', function (evt) { initAll(evt.target); });
  document.addEventListener('shopify:section:unload', function (evt) { destroyAll(evt.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["homepage-game-picker"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__bsGpCarouselInit) return;
  window.__bsGpCarouselInit = true;

  var instances = {};

  function reduceMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function isRtl(track) {
    return getComputedStyle(track).direction === 'rtl';
  }

  // Measure the first real card rather than assume a fixed width, so this
  // keeps working whatever card-gap/columns the merchant configures.
  function scrollAmount(track) {
    var card = track.querySelector('[data-gp-card]');
    if (!card) return 320;
    var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
    return card.getBoundingClientRect().width + gap;
  }

  function updateButtons(inst) {
    var track = inst.track;
    var rtl = isRtl(track);
    var hasOverflow = track.scrollWidth > track.clientWidth + 4;
    var atStart = rtl ? track.scrollLeft >= -4 : track.scrollLeft <= 4;
    var atEnd = rtl
      ? track.scrollLeft <= -(track.scrollWidth - track.clientWidth - 4)
      : track.scrollLeft >= track.scrollWidth - track.clientWidth - 4;
    if (inst.prev) { inst.prev.hidden = !hasOverflow; inst.prev.disabled = atStart; }
    if (inst.next) { inst.next.hidden = !hasOverflow; inst.next.disabled = atEnd; }
  }

  function scrollByOneCard(inst, dir) {
    var rtl = isRtl(inst.track);
    var amt = scrollAmount(inst.track) * (rtl ? -dir : dir);
    inst.track.scrollBy({ left: amt, behavior: reduceMotion() ? 'auto' : 'smooth' });
  }

  function initInstance(root) {
    if (!root || root.__gpInit) return;

    var track = root.querySelector('[data-gp-track]');
    var prev = root.querySelector('[data-gp-prev]');
    var next = root.querySelector('[data-gp-next]');
    if (!track) return;

    root.__gpInit = true;

    var inst = { root: root, track: track, prev: prev, next: next };

    function onPrev() { scrollByOneCard(inst, -1); }
    function onNext() { scrollByOneCard(inst, 1); }
    function onScroll() { updateButtons(inst); }
    function onResize() { updateButtons(inst); }

    if (prev) prev.addEventListener('click', onPrev);
    if (next) next.addEventListener('click', onNext);
    track.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);

    inst.selectCard = function (cardEl) {
      cardEl.scrollIntoView({ behavior: reduceMotion() ? 'auto' : 'smooth', block: 'nearest', inline: 'center' });
    };

    inst.destroy = function () {
      if (prev) prev.removeEventListener('click', onPrev);
      if (next) next.removeEventListener('click', onNext);
      track.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', onResize);
      root.__gpInit = false;
    };

    updateButtons(inst);
    instances[root.id] = inst;
  }

  function destroyInstance(id) {
    var inst = instances[id];
    if (!inst) return;
    inst.destroy();
    delete instances[id];
  }

  function carouselsIn(root) {
    var list = [];
    if (root.matches && root.matches('[data-gp-carousel]')) list.push(root);
    if (root.querySelectorAll) {
      Array.prototype.forEach.call(root.querySelectorAll('[data-gp-carousel]'), function (el) { list.push(el); });
    }
    return list;
  }

  function initAll(root) { carouselsIn(root).forEach(initInstance); }
  function destroyAll(root) { carouselsIn(root).forEach(function (el) { destroyInstance(el.id); }); }

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  ready(function () { initAll(document); });

  document.addEventListener('shopify:section:load', function (evt) {
    initAll(evt.target);
  });

  document.addEventListener('shopify:section:unload', function (evt) {
    destroyAll(evt.target);
  });

  document.addEventListener('shopify:block:select', function (evt) {
    var cardEl = evt.target && evt.target.closest ? evt.target.closest('[data-gp-card]') : null;
    if (!cardEl) return;
    var carousel = cardEl.closest('[data-gp-carousel]');
    if (!carousel) return;
    var inst = instances[carousel.id];
    if (inst && inst.selectCard) inst.selectCard(cardEl);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
